import React from 'react';
import './Sitemap2.css'; // Import the CSS file for styling

const Sitemap2 = () => {
  return (
    <div className="sitemap2-container">
      <header>
        <h1>Site Map</h1>
      </header>
      <main>
        <div className="sitemap2">
          <h2>Primary Navigation</h2>
          <ul>
            <li><a href="/">Home</a></li>
            <li>
                <h6>Products</h6>
              <ul>
                <li>
                  <a href="https://app.credithaat.com/pl_journey?dsa=285197218&source=PLJourney">Personal Loan</a>
                  <ul>
            <li><a href="/PersonalLoanCity/Kolkata">Personal Loan in Kolkata</a></li>
            <li><a href="/PersonalLoanCity/Hyderabad">Personal Loan in Hyderabad</a></li>
            <li><a href="/PersonalLoanCity/Chennai">Personal Loan in Chennai</a></li>
            <li><a href="/PersonalLoanCity/Mumbai">Personal Loan in Mumbai</a></li>
            <li><a href="/PersonalLoanCity/Delhi">Personal Loan in Delhi</a></li>
            <li><a href="/PersonalLoanCity/Pune">Personal Loan in Pune</a></li>
            <li><a href="/PersonalLoanCity/Bangalore">Personal Loan in Bangalore</a></li>
            <li><a href="/PersonalLoanCity/Jaipur">Personal Loan in Jaipur</a></li>
            <li><a href="/PersonalLoanCity/Hubli">Personal Loan in Hubli</a></li>
            <li><a href="/PersonalLoanCity/Coimbatore">Personal Loan in Coimbatore</a></li>
            <li><a href="/PersonalLoanCity/Surat">Personal Loan in Surat</a></li>
            <li><a href="/PersonalLoanCity/Nagpur">Personal Loan in Nagpur</a></li>
            <li><a href="/PersonalLoanCity/Indore">Personal Loan in Indore</a></li>
            <li><a href="/PersonalLoanCity/Vijayawada">Personal Loan in Vijayawada</a></li>
            <li><a href="/PersonalLoanCity/Vadodara">Personal Loan in Vadodara</a></li>
            <li><a href="/PersonalLoanCity/Kochi">Personal Loan in Kochi</a></li>
            <li><a href="/PersonalLoanCity/Gwalior">Personal Loan in Gwalior</a></li>
            <li><a href="/PersonalLoanCity/Varanasi">Personal Loan in Varanasi</a></li>
            <li><a href="/PersonalLoanCity/Patna">Personal Loan in Patna</a></li>
            <li><a href="/PersonalLoanCity/Dehradun">Personal Loan in Dehradun</a></li>
            <li><a href="/PersonalLoanCity/Chandigarh">Personal Loan in Chandigarh</a></li>
            <li><a href="/PersonalLoanCity/Mangalore">Personal Loan in Mangalore</a></li>
            <li><a href="/PersonalLoanCity/Lucknow">Personal Loan in Lucknow</a></li>
            <li><a href="/PersonalLoanCity/Thiruvananthapuram">Personal Loan in Thiruvananthapuram</a></li>
            <li><a href="/PersonalLoanCity/Mysore">Personal Loan in Mysore</a></li>
            <li><a href="/PersonalLoanCity/Jamshedpur">Personal Loan in Jamshedpur</a></li>
            <li><a href="/PersonalLoanCity/Kanpur">Personal Loan in Kanpur</a></li>
            <li><a href="/PersonalLoanCity/Kota">Personal Loan in Kota</a></li>
            <li><a href="/PersonalLoanCity/Visakhapatnam">Personal Loan in Visakhapatnam</a></li>
            <li><a href="/PersonalLoanCity/Raipur">Personal Loan in Raipur</a></li>
            <li><a href="/PersonalLoanCity/Bhopal">Personal Loan in Bhopal</a></li>
            <li><a href="/PersonalLoanCity/Jodhpur">Personal Loan in Jodhpur</a></li>
            <li><a href="/PersonalLoanCity/Cuttack">Personal Loan in Cuttack</a></li>
            <li><a href="/PersonalLoanCity/Bhubaneswar">Personal Loan in Bhubaneswar</a></li>
            <li><a href="/PersonalLoanCity/Noida">Personal Loan in Noida</a></li>
            <li><a href="/PersonalLoanCity/Gurgaon">Personal Loan in Gurgaon</a></li>
            <li><a href="/PersonalLoanCity/Ahmedabad">Personal Loan in Ahmedabad</a></li>
            <li><a href="/PersonalLoanCity/Goa">Personal Loan in Goa</a></li>
            <li><a href="/PersonalLoanCity/Agra">Personal Loan in Agra</a></li>
            <li><a href="/PersonalLoanCity/Ahmednagar">Personal Loan in Ahmednagar</a></li>
            <li><a href="/PersonalLoanCity/Akola">Personal Loan in Akola</a></li>
            <li><a href="/PersonalLoanCity/Bareilly">Personal Loan in Bareilly</a></li>
            <li><a href="/PersonalLoanCity/Beed">Personal Loan in Beed</a></li>
            <li><a href="/PersonalLoanCity/Bhusawal">Personal Loan in Bhusawal</a></li>
            <li><a href="/PersonalLoanCity/Chandrapur">Personal Loan in Chandrapur</a></li>
            <li><a href="/PersonalLoanCity/Dhule">Personal Loan in Dhule</a></li>
            <li><a href="/PersonalLoanCity/Gondia">Personal Loan in Gondia</a></li>
            <li><a href="/PersonalLoanCity/Jalna">Personal Loan in Jalna</a></li>
            <li><a href="/PersonalLoanCity/Jhansi">Personal Loan in Jhansi</a></li>
            <li><a href="/PersonalLoanCity/Kalyan">Personal Loan in Kalyan</a></li>
            <li><a href="/PersonalLoanCity/Karad">Personal Loan in Karad</a></li>
            <li><a href="/PersonalLoanCity/Kolhapur">Personal Loan in Kolhapur</a></li>
            <li><a href="/PersonalLoanCity/Latur">Personal Loan in Latur</a></li>
            <li><a href="/PersonalLoanCity/Nanded">Personal Loan in Nanded</a></li>
            <li><a href="/PersonalLoanCity/Nashik">Personal Loan in Nashik</a></li>
            <li><a href="/PersonalLoanCity/Mumbai">Personal Loan in Navi Mumbai</a></li>
            <li><a href="/PersonalLoanCity/Osmanabad">Personal Loan in Osmanabad</a></li>
            <li><a href="/PersonalLoanCity/Panvel">Personal Loan in Panvel</a></li>
            <li><a href="/PersonalLoanCity/Parbhani">Personal Loan in Parbhani</a></li>
            <li><a href="/PersonalLoanCity/Pimpri-Chinchwad">Personal Loan in Pimpri-Chinchwad</a></li>
            <li><a href="/PersonalLoanCity/Sambhajinagar">Personal Loan in Sambhajinagar</a></li>
            <li><a href="/PersonalLoanCity/Satara">Personal Loan in Satara</a></li>
            <li><a href="/PersonalLoanCity/Solapur">Personal Loan in Solapur</a></li>
            <li><a href="/PersonalLoanCity/Srinagar">Personal Loan in Srinagar</a></li>
            <li><a href="/PersonalLoanCity/Thane">Personal Loan in Thane</a></li>
            <li><a href="/PersonalLoanCity/Tirupati">Personal Loan in Tirupati</a></li>
            <li><a href="/PersonalLoanCity/Udaipur">Personal Loan in Udaipur</a></li>
            <li><a href="/PersonalLoanCity/Ulhasnagar">Personal Loan in Ulhasnagar</a></li>
            <li><a href="/PersonalLoanCity/Vasai-Virar">Personal Loan in Vasai-Virar</a></li>
            <li><a href="/PersonalLoanCity/Wardha">Personal Loan in Wardha</a></li>
            <li><a href="/PersonalLoanCity/Yavatmal">Personal Loan in Yavatmal</a></li>
            <li><a href="/PersonalLoanCity/Ambala">Personal Loan in Ambala</a></li>
            <li><a href="/PersonalLoanCity/Amritsar">Personal Loan in Amritsar</a></li>
            <li><a href="/PersonalLoanCity/Bhilwara">Personal Loan in Bhilwara</a></li>
            <li><a href="/PersonalLoanCity/Bhuj">Personal Loan in Bhuj</a></li>
            <li><a href="/PersonalLoanCity/Bilaspur">Personal Loan in Bilaspur</a></li>
            <li><a href="/PersonalLoanCity/Buldhana">Personal Loan in Buldhana</a></li>
            <li><a href="/PersonalLoanCity/Faridabad">Personal Loan in Faridabad</a></li>
            <li><a href="/PersonalLoanCity/Gandhinagar">Personal Loan in Gandhinagar</a></li>
            <li><a href="/PersonalLoanCity/Ghaziabad">Personal Loan in Ghaziabad</a></li>
            <li><a href="/PersonalLoanCity/Gorakhpur">Personal Loan in Gorakhpur</a></li>
            <li><a href="/PersonalLoanCity/Guntur">Personal Loan in Guntur</a></li>
            <li><a href="/PersonalLoanCity/Guwahati">Personal Loan in Guwahati</a></li>
            <li><a href="/PersonalLoanCity/Hingoli">Personal Loan in Hingoli</a></li>
            <li><a href="/PersonalLoanCity/Jalandhar">Personal Loan in Jalandhar</a></li>
            <li><a href="/PersonalLoanCity/Jabalpur">Personal Loan in Jabalpur</a></li>
            <li><a href="/PersonalLoanCity/Kannur">Personal Loan in Kannur</a></li>
            <li><a href="/PersonalLoanCity/Ludhiana">Personal Loan in Ludhiana</a></li>
            <li><a href="/PersonalLoanCity/Malegaon">Personal Loan in Malegaon</a></li>
            <li><a href="/PersonalLoanCity/Malvan">Personal Loan in Malvan</a></li>
            <li><a href="/PersonalLoanCity/Meerut">Personal Loan in Meerut</a></li>
            <li><a href="/PersonalLoanCity/Moradabad">Personal Loan in Moradabad</a></li>
            <li><a href="/PersonalLoanCity/Palghar">Personal Loan in Palghar</a></li>
            <li><a href="/PersonalLoanCity/Prayagraj">Personal Loan in Prayagraj</a></li>
            <li><a href="/PersonalLoanCity/Raigad">Personal Loan in Raigad</a></li>
            <li><a href="/PersonalLoanCity/Rajkot">Personal Loan in Rajkot</a></li>
            <li><a href="/PersonalLoanCity/Rameswaram">Personal Loan in Rameswaram</a></li>
            <li><a href="/PersonalLoanCity/Ranchi">Personal Loan in Ranchi</a></li>
            <li><a href="/PersonalLoanCity/Ratnagiri">Personal Loan in Ratnagiri</a></li>
            <li><a href="/PersonalLoanCity/Saharanpur">Personal Loan in Saharanpur</a></li>
            <li><a href="/PersonalLoanCity/Sangli">Personal Loan in Sangli</a></li>
            <li><a href="/PersonalLoanCity/Ujjain">Personal Loan in Ujjain</a></li>
            <li><a href="/PersonalLoanCity/Washim">Personal Loan in Washim</a></li>
            <li><a href="/PersonalLoanCity/Wayanad">Personal Loan in Wayanad</a></li>
            <li><a href="/PersonalLoanCity/Ooty">Personal Loan in Ooty</a></li>
            <li><a href="/PersonalLoanCity/Rishikesh">Personal Loan in Rishikesh</a></li>
            <li><a href="/PersonalLoanCity/Jaisalmer">Personal Loan in Jaisalmer</a></li>
            <li><a href="/PersonalLoanCity/Jalgaon">Personal Loan in Jalgaon</a></li>
            <li><a href="/PersonalLoanCity/Jammu">Personal Loan in Jammu</a></li>
            <li><a href="/PersonalLoanCity/Madurai">Personal Loan in Madurai</a></li>
            <li><a href="/PersonalLoanCity/Ajmer">Personal Loan in Ajmer</a></li>
            <li><a href="/PersonalLoanCity/Kalaburagi">Personal Loan in Kalaburagi</a></li>
            <li><a href="/PersonalLoanCity/Nadiad">Personal Loan in Nadiad</a></li>
            <li><a href="/PersonalLoanCity/Bhiwandi">Personal Loan in Bhiwandi</a></li>
            <li><a href="/PersonalLoanCity/Kurnool">Personal Loan in Kurnool</a></li>
            <li><a href="/PersonalLoanCity/Karnal">Personal Loan in Karnal</a></li>
            <li><a href="/PersonalLoanCity/Bhavnagar">Personal Loan in Bhavnagar</a></li>
            <li><a href="/PersonalLoanCity/Anand">Personal Loan in Anand</a></li>
            <li><a href="/PersonalLoanCity/Aligarh">Personal Loan in Aligarh</a></li>
            <li><a href="/PersonalLoanCity/Bikaner">Personal Loan in Bikaner</a></li>
            <li><a href="/PersonalLoanCity/Dombivli">Personal Loan in Dombivli</a></li>
            <li><a href="/PersonalLoanCity/Kakinada">Personal Loan in Kakinada</a></li>
            <li><a href="/PersonalLoanCity/Mathura">Personal Loan in Mathura</a></li>
            <li><a href="/PersonalLoanCity/Salem">Personal Loan in Salem</a></li>
            <li><a href="/PersonalLoanCity/Kozhikode">Personal Loan in Kozhikode</a></li>
            <li><a href="/PersonalLoanCity/Tirunelveli">Personal Loan in Tirunelveli</a></li>
            <li><a href="/PersonalLoanCity/Bhilai">Personal Loan in Bhilai</a></li>
            <li><a href="/PersonalLoanCity/Dahod">Personal Loan in Dahod</a></li>
                  </ul>
                </li>
                <li>
                  <a href="/BusinessLoan">Business Loan</a>
                  <ul>
                  <li><a href="/BusinessLoanCity/Kolkata">Business Loan in Kolkata</a></li>
            <li><a href="/BusinessLoanCity/Hyderabad">Business Loan in Hyderabad</a></li>
            <li><a href="/BusinessLoanCity/Chennai">Business Loan in Chennai</a></li>
            <li><a href="/BusinessLoanCity/Mumbai">Business Loan in Mumbai</a></li>
            <li><a href="/BusinessLoanCity/Delhi">Business Loan in Delhi</a></li>
            <li><a href="/BusinessLoanCity/Pune">Business Loan in Pune</a></li>
            <li><a href="/BusinessLoanCity/Bangalore">Business Loan in Bangalore</a></li>
            <li><a href="/BusinessLoanCity/Jaipur">Business Loan in Jaipur</a></li>
            <li><a href="/BusinessLoanCity/Hubli">Business Loan in Hubli</a></li>
            <li><a href="/BusinessLoanCity/Coimbatore">Business Loan in Coimbatore</a></li>
            <li><a href="/BusinessLoanCity/Surat">Business Loan in Surat</a></li>
            <li><a href="/BusinessLoanCity/Nagpur">Business Loan in Nagpur</a></li>
            <li><a href="/BusinessLoanCity/Indore">Business Loan in Indore</a></li>
            <li><a href="/BusinessLoanCity/Vijayawada">Business Loan in Vijayawada</a></li>
            <li><a href="/BusinessLoanCity/Vadodara">Business Loan in Vadodara</a></li>
            <li><a href="/BusinessLoanCity/Kochi">Business Loan in Kochi</a></li>
            <li><a href="/BusinessLoanCity/Gwalior">Business Loan in Gwalior</a></li>
            <li><a href="/BusinessLoanCity/Varanasi">Business Loan in Varanasi</a></li>
            <li><a href="/BusinessLoanCity/Patna">Business Loan in Patna</a></li>
            <li><a href="/BusinessLoanCity/Dehradun">Business Loan in Dehradun</a></li>
            <li><a href="/BusinessLoanCity/Chandigarh">Business Loan in Chandigarh</a></li>
            <li><a href="/BusinessLoanCity/Mangalore">Business Loan in Mangalore</a></li>
            <li><a href="/BusinessLoanCity/Lucknow">Business Loan in Lucknow</a></li>
            <li><a href="/BusinessLoanCity/Thiruvananthapuram">Business Loan in Thiruvananthapuram</a></li>
            <li><a href="/BusinessLoanCity/Mysore">Business Loan in Mysore</a></li>
            <li><a href="/BusinessLoanCity/Jamshedpur">Business Loan in Jamshedpur</a></li>
            <li><a href="/BusinessLoanCity/Kanpur">Business Loan in Kanpur</a></li>
            <li><a href="/BusinessLoanCity/Kota">Business Loan in Kota</a></li>
            <li><a href="/BusinessLoanCity/Visakhapatnam">Business Loan in Visakhapatnam</a></li>
            <li><a href="/BusinessLoanCity/Raipur">Business Loan in Raipur</a></li>
            <li><a href="/BusinessLoanCity/Bhopal">Business Loan in Bhopal</a></li>
            <li><a href="/BusinessLoanCity/Jodhpur">Business Loan in Jodhpur</a></li>
            <li><a href="/BusinessLoanCity/Cuttack">Business Loan in Cuttack</a></li>
            <li><a href="/BusinessLoanCity/Bhubaneswar">Business Loan in Bhubaneswar</a></li>
            <li><a href="/BusinessLoanCity/Noida">Business Loan in Noida</a></li>
            <li><a href="/BusinessLoanCity/Gurgaon">Business Loan in Gurgaon</a></li>
            <li><a href="/BusinessLoanCity/Ahmedabad">Business Loan in Ahmedabad</a></li>
            <li><a href="/BusinessLoanCity/Goa">Business Loan in Goa</a></li>
            <li><a href="/BusinessLoanCity/Agra">Business Loan in Agra</a></li>
            <li><a href="/BusinessLoanCity/Ahmednagar">Business Loan in Ahmednagar</a></li>
            <li><a href="/BusinessLoanCity/Akola">Business Loan in Akola</a></li>
            <li><a href="/BusinessLoanCity/Bareilly">Business Loan in Bareilly</a></li>
            <li><a href="/BusinessLoanCity/Beed">Business Loan in Beed</a></li>
            <li><a href="/BusinessLoanCity/Bhusawal">Business Loan in Bhusawal</a></li>
            <li><a href="/BusinessLoanCity/Chandrapur">Business Loan in Chandrapur</a></li>
            <li><a href="/BusinessLoanCity/Dhule">Business Loan in Dhule</a></li>
            <li><a href="/BusinessLoanCity/Gondia">Business Loan in Gondia</a></li>
            <li><a href="/BusinessLoanCity/Jalna">Business Loan in Jalna</a></li>
            <li><a href="/BusinessLoanCity/Jhansi">Business Loan in Jhansi</a></li>
            <li><a href="/BusinessLoanCity/Kalyan">Business Loan in Kalyan</a></li>
            <li><a href="/BusinessLoanCity/Karad">Business Loan in Karad</a></li>
            <li><a href="/BusinessLoanCity/Kolhapur">Business Loan in Kolhapur</a></li>
            <li><a href="/BusinessLoanCity/Latur">Business Loan in Latur</a></li>
            <li><a href="/BusinessLoanCity/Nanded">Business Loan in Nanded</a></li>
            <li><a href="/BusinessLoanCity/Nashik">Business Loan in Nashik</a></li>
            <li><a href="/BusinessLoanCity/Mumbai">Business Loan in Navi Mumbai</a></li>
            <li><a href="/BusinessLoanCity/Osmanabad">Business Loan in Osmanabad</a></li>
            <li><a href="/BusinessLoanCity/Panvel">Business Loan in Panvel</a></li>
            <li><a href="/BusinessLoanCity/Parbhani">Business Loan in Parbhani</a></li>
            <li><a href="/BusinessLoanCity/Pimpri-Chinchwad">Business Loan in Pimpri-Chinchwad</a></li>
            <li><a href="/BusinessLoanCity/Sambhajinagar">Business Loan in Sambhajinagar</a></li>
            <li><a href="/BusinessLoanCity/Satara">Business Loan in Satara</a></li>
            <li><a href="/BusinessLoanCity/Solapur">Business Loan in Solapur</a></li>
            <li><a href="/BusinessLoanCity/Srinagar">Business Loan in Srinagar</a></li>
            <li><a href="/BusinessLoanCity/Thane">Business Loan in Thane</a></li>
            <li><a href="/BusinessLoanCity/Tirupati">Business Loan in Tirupati</a></li>
            <li><a href="/BusinessLoanCity/Udaipur">Business Loan in Udaipur</a></li>
            <li><a href="/BusinessLoanCity/Ulhasnagar">Business Loan in Ulhasnagar</a></li>
            <li><a href="/BusinessLoanCity/Vasai-Virar">Business Loan in Vasai-Virar</a></li>
            <li><a href="/BusinessLoanCity/Wardha">Business Loan in Wardha</a></li>
            <li><a href="/BusinessLoanCity/Yavatmal">Business Loan in Yavatmal</a></li>
            <li><a href="/BusinessLoanCity/Ambala">Business Loan in Ambala</a></li>
            <li><a href="/BusinessLoanCity/Amritsar">Business Loan in Amritsar</a></li>
            <li><a href="/BusinessLoanCity/Bhilwara">Business Loan in Bhilwara</a></li>
            <li><a href="/BusinessLoanCity/Bhuj">Business Loan in Bhuj</a></li>
            <li><a href="/BusinessLoanCity/Bilaspur">Business Loan in Bilaspur</a></li>
            <li><a href="/BusinessLoanCity/Buldhana">Business Loan in Buldhana</a></li>
            <li><a href="/BusinessLoanCity/Faridabad">Business Loan in Faridabad</a></li>
            <li><a href="/BusinessLoanCity/Gandhinagar">Business Loan in Gandhinagar</a></li>
            <li><a href="/BusinessLoanCity/Ghaziabad">Business Loan in Ghaziabad</a></li>
            <li><a href="/BusinessLoanCity/Gorakhpur">Business Loan in Gorakhpur</a></li>
            <li><a href="/BusinessLoanCity/Guntur">Business Loan in Guntur</a></li>
            <li><a href="/BusinessLoanCity/Guwahati">Business Loan in Guwahati</a></li>
            <li><a href="/BusinessLoanCity/Hingoli">Business Loan in Hingoli</a></li>
            <li><a href="/BusinessLoanCity/Jalandhar">Business Loan in Jalandhar</a></li>
            <li><a href="/BusinessLoanCity/Jabalpur">Business Loan in Jabalpur</a></li>
            <li><a href="/BusinessLoanCity/Kannur">Business Loan in Kannur</a></li>
            <li><a href="/BusinessLoanCity/Ludhiana">Business Loan in Ludhiana</a></li>
            <li><a href="/BusinessLoanCity/Malegaon">Business Loan in Malegaon</a></li>
            <li><a href="/BusinessLoanCity/Malvan">Business Loan in Malvan</a></li>
            <li><a href="/BusinessLoanCity/Meerut">Business Loan in Meerut</a></li>
            <li><a href="/BusinessLoanCity/Moradabad">Business Loan in Moradabad</a></li>
            <li><a href="/BusinessLoanCity/Palghar">Business Loan in Palghar</a></li>
            <li><a href="/BusinessLoanCity/Prayagraj">Business Loan in Prayagraj</a></li>
            <li><a href="/BusinessLoanCity/Raigad">Business Loan in Raigad</a></li>
            <li><a href="/BusinessLoanCity/Rajkot">Business Loan in Rajkot</a></li>
            <li><a href="/BusinessLoanCity/Rameswaram">Business Loan in Rameswaram</a></li>
            <li><a href="/BusinessLoanCity/Ranchi">Business Loan in Ranchi</a></li>
            <li><a href="/BusinessLoanCity/Ratnagiri">Business Loan in Ratnagiri</a></li>
            <li><a href="/BusinessLoanCity/Saharanpur">Business Loan in Saharanpur</a></li>
            <li><a href="/BusinessLoanCity/Sangli">Business Loan in Sangli</a></li>
            <li><a href="/BusinessLoanCity/Ujjain">Business Loan in Ujjain</a></li>
            <li><a href="/BusinessLoanCity/Washim">Business Loan in Washim</a></li>
            <li><a href="/BusinessLoanCity/Wayanad">Business Loan in Wayanad</a></li>
            <li><a href="/BusinessLoanCity/Ooty">Business Loan in Ooty</a></li>
            <li><a href="/BusinessLoanCity/Rishikesh">Business Loan in Rishikesh</a></li>
            <li><a href="/BusinessLoanCity/Jaisalmer">Business Loan in Jaisalmer</a></li>
            <li><a href="/BusinessLoanCity/Jalgaon">Business Loan in Jalgaon</a></li>
            <li><a href="/BusinessLoanCity/Jammu">Business Loan in Jammu</a></li>
            <li><a href="/BusinessLoanCity/Madurai">Business Loan in Madurai</a></li>
            <li><a href="/BusinessLoanCity/Ajmer">Business Loan in Ajmer</a></li>
            <li><a href="/BusinessLoanCity/Kalaburagi">Business Loan in Kalaburagi</a></li>
            <li><a href="/BusinessLoanCity/Nadiad">Business Loan in Nadiad</a></li>
            <li><a href="/BusinessLoanCity/Bhiwandi">Business Loan in Bhiwandi</a></li>
            <li><a href="/BusinessLoanCity/Kurnool">Business Loan in Kurnool</a></li>
            <li><a href="/BusinessLoanCity/Karnal">Business Loan in Karnal</a></li>
            <li><a href="/BusinessLoanCity/Bhavnagar">Business Loan in Bhavnagar</a></li>
            <li><a href="/BusinessLoanCity/Anand">Business Loan in Anand</a></li>
            <li><a href="/BusinessLoanCity/Aligarh">Business Loan in Aligarh</a></li>
            <li><a href="/BusinessLoanCity/Bikaner">Business Loan in Bikaner</a></li>
            <li><a href="/BusinessLoanCity/Dombivli">Business Loan in Dombivli</a></li>
            <li><a href="/BusinessLoanCity/Kakinada">Business Loan in Kakinada</a></li>
            <li><a href="/BusinessLoanCity/Mathura">Business Loan in Mathura</a></li>
            <li><a href="/BusinessLoanCity/Salem">Business Loan in Salem</a></li>
            <li><a href="/BusinessLoanCity/Kozhikode">Business Loan in Kozhikode</a></li>
            <li><a href="/BusinessLoanCity/Tirunelveli">Business Loan in Tirunelveli</a></li>
            <li><a href="/BusinessLoanCity/Bhilai">Business Loan in Bhilai</a></li>
            <li><a href="/BusinessLoanCity/Dahod">Business Loan in Dahod</a></li>
                  </ul>
                </li>
                <li><a href="/CreditCard">Credit Card</a></li>
              </ul>
            </li>
            <li><a href="/Contactus">Contact us</a></li>
          </ul>
          <h2>Footer</h2>
          <ul>
         
            <li><a href="/NewAllPartners">Lending partners</a></li>
            <li><a href="/acq">Acquisition partner</a></li>
            <li><a href="/gro">Grievance redressal process</a></li>
            <li><a href="/CreditScore">Credit score</a></li>
            <li><a href="/TermsC">Terms of service</a></li>
            <li><a href="/privacy">Privacy policy</a></li>
          </ul>
        </div>
      </main>
      <footer>
        <p style={{textAlign:'center',backgroundColor:'#f4f4f4',padding:'10px',marginTop:'20px'}}>&copy; 2024 CreditHaat</p>
      </footer>
    </div>
  );
};

export default Sitemap2;
